import moment from 'moment'
import {addLocale} from 'primereact/api'
import {Calendar} from 'primereact/calendar'
import {forwardRef, useCallback, useImperativeHandle, useState} from 'react'
import {useAppConfig} from '../../context/app/AppContext'
import {getLanguageCode} from '../../i18n/LanguageUtils'
import TranslateUtils from '../../i18n/TranslateUtils'
import {bgLocale} from './CalendarConstant'
import './style/calendar.css'
const CalendarUtils = forwardRef(
    (
        {
            placeholder,
            label,
            showTime = true,
            observation = false,
            disabled = false,
            classNameCalendar,
        },
        ref,
    ) => {
        const {timezoneId} = useAppConfig()
        const {translateCommons} = TranslateUtils()
        useImperativeHandle(ref, () => ({
            value: value,
        }))

        const [value, setValue] = useState(new Date())

        // Locale
        addLocale('bg', bgLocale)

        const renderCalendarFooter = useCallback(() => {
            if (!value) {
                return null
            }

            const pattern = 'DD-MM-YYYY HH:mm a'
            const dataTime = value ? moment(value) : moment()

            const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone

            const dateWithClientTz = dataTime.utc().tz(timezoneId)

            return (
                <div className="col-12 m-0 pt-0">
                    <div className="flex flex-wrap font-semibold pb-1">
                        <p className="text-700 m-0 p-0 pr-1">
                            {translateCommons('Your current date time ')} (
                            {userTz} GMT
                            {dataTime.tz(userTz).format('Z')}
                            ):
                        </p>
                        <p className="text-primary font-bold w-12rem m-0 p-0">
                            {dataTime.format(`${pattern}`)}
                        </p>
                    </div>
                    <div className="flex flex-wrap font-semibold pb-1">
                        <p className="text-700 m-0 p-0 pr-1">
                            {translateCommons(
                                "Date time based on Client's time zone ",
                            )}{' '}
                            ({timezoneId} GMT
                            {dataTime.tz(timezoneId).format('Z')}):
                        </p>
                        <p className="text-primary font-bold w-12rem m-0 p-0">
                            {dateWithClientTz.format(`${pattern}`)}
                        </p>
                    </div>
                </div>
            )
        }, [timezoneId, translateCommons, value])

        return (
            <div className="col-12 p-0">
                {!observation ? (
                    <div>
                        <Calendar
                            locale={
                                getLanguageCode() === 'en' ||
                                getLanguageCode() === 'gb'
                                    ? 'en'
                                    : getLanguageCode()
                            }
                            className={`${
                                classNameCalendar ? classNameCalendar : 'col-12'
                            } m-0 p-0`}
                            value={value}
                            onChange={e => setValue(e.value)}
                            showTime={!!showTime}
                            showSeconds={!!showTime}
                            placeholder={placeholder}
                            hourFormat="24"
                            disabled={disabled}
                            dateFormat="dd-mm-yy"
                            hideOnDateTimeSelect={true}
                        />
                        {renderCalendarFooter()}
                    </div>
                ) : (
                    <div>
                        <Calendar
                            locale={
                                getLanguageCode() === 'en' ||
                                getLanguageCode() === 'gb'
                                    ? 'en'
                                    : getLanguageCode() || null
                            }
                            className="custom-calendar col-12"
                            value={value}
                            inline
                            hourFormat="24"
                            dateFormat="dd-mm-yy"
                            onChange={e => setValue(e.value)}
                            showTime
                            disabled={disabled}
                            hideOnDateTimeSelect={true}
                        />
                        {renderCalendarFooter()}
                    </div>
                )}
            </div>
        )
    },
)

export default CalendarUtils
